import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { app } from '@api/axiosAPI';
import { replaceNewLine } from '@lib/utils';
import parse from 'html-react-parser';

const AppDownloadTemplate = () => {
  const navigate = useNavigate();
  const [appInfo, setAppInfo] = useState();

  const osDivCd = '024001';
  const { data } = app.getLastAppVersion(['getLastAppVersion', osDivCd], { enabled: true }, { osDivCd: osDivCd });

  useEffect(() => {
    setAppInfo(data);
    console.log(data);
  }, [data]);

  const onClickDwld = () => {
    if (appInfo && appInfo.appFileUrl) {
      const confirmation = window.confirm('헬스업 앱이 설치되어 있는 경우에는 먼저 앱을 삭제 후 설치해야 합니다. \n계속 하시겠습니까?');
      if (confirmation) {
        window.location.href = appInfo.appFileUrl;
      }
    }
  };

  const onClickComInfo = () => {
    window.location.href = 'https://openit.co.kr';
  };

  const onClickUseCl = () => {
    navigate('/term/CL001');
  };

  const onClickPriCl = () => {
    navigate('/term/CL002');
  };

  return (
    <div className="flex colum Height-100 bg-white">
      <div className="home_wrap mt-40">
        <div className="Padding-20">
          <div className="flex">
            <div className="logo__box">
              <img src="/assets/images/img_appDownload.svg" alt="HealthUp" />
            </div>
            <div className="app_info ml-20">
              <p className="fs-20 fw-e font-black mt-5">HealthUp</p>
              <p className="fs-14 font-black mt-5">{`ver ${appInfo?.appVerVal} (${appInfo?.appVerDivCdNm})`}</p>
              <p className="fs-14 font-666 mt-5">{appInfo?.aplyStaDtm}</p>
              <p className="fs-14 font-666 mt-5">{appInfo?.osDivCdNm}</p>
            </div>
          </div>
          <div className="mt-30">
            <p className="font-black fs-16 fw-r lh-24">{parse(replaceNewLine(appInfo?.rlseCtt || ''))}</p>
          </div>
          <button type="button" className="btn_appdownload mt-30 fs-16 fw-b" onClick={onClickDwld}>
            다운로드
          </button>
        </div>
      </div>
      <section className="footer_wrap mt-Auto position-r mt-50">
        <div className="flex pb-20 b-b-solid bc-999 fs-14">
          <span id="btm_link_1" className="pl-10 pr-10" onClick={onClickComInfo}>
            회사소개
          </span>
          <span id="btm_link_2" className="pl-10 pr-10" onClick={onClickUseCl}>
            이용약관
          </span>
          <span id="btm_link_3" className="pl-10 pr-10" onClick={onClickPriCl}>
            개인정보처리방침
          </span>
        </div>
        <div className="pl-10 pt-20 fs-13 lh-22">
          (주)오픈잇
          <br />
          대표이사 : 김민영
          <br />
          서울특별시 성동구 아차산로 17길 57, 6층(휴먼테코)
          <br />
          Tel : 1566-5811 e-mail : help@openit.co.kr
          <br />
          사업자등록번호 : 214-88-11195
        </div>
      </section>
    </div>
  );
};

export default AppDownloadTemplate;
